import { motion } from "framer-motion";
import { HERO, IMAGES } from "@/content";

export const Hero = () => (
  <section data-testid="hero-section" className="grid min-h-screen bg-[#F6F5F2] lg:grid-cols-2">
    <div className="relative h-[62vh] min-h-[420px] overflow-hidden lg:order-2 lg:h-auto lg:min-h-screen">
      <motion.img
        data-testid="hero-portrait"
        src={IMAGES.portrait}
        alt="Melanie Collins aboard a Gulfstream cabin"
        className="h-full w-full object-cover object-top"
        initial={{ scale: 1.06 }}
        animate={{ scale: 1 }}
        transition={{ duration: 2.2, ease: [0.22, 1, 0.36, 1] }}
      />
    </div>
    <div className="flex items-center px-6 pb-16 pt-10 lg:order-1 lg:px-14 lg:pt-24">
      <div className="max-w-xl">
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="mb-6 flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.25em] text-[#D18237]"
        >
          <span className="h-px w-10 bg-[#D18237]" />
          <span>{HERO.overline}</span>
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="text-sm font-semibold uppercase tracking-[0.3em] text-[#4A525B]"
        >
          {HERO.name}
        </motion.h2>
        <h1 className="mt-6 font-serif text-4xl leading-[1.1] tracking-tight text-[#0A0F16] sm:text-5xl lg:text-6xl">
          {HERO.lines.map((line, i) => (
            <span key={i} className="block overflow-hidden pb-1">
              <motion.span
                className={`block ${line.italic ? "italic text-[#B06A24]" : ""}`}
                initial={{ y: "115%" }}
                animate={{ y: 0 }}
                transition={{ duration: 1, delay: 0.45 + i * 0.15, ease: [0.22, 1, 0.36, 1] }}
              >
                {line.text}
              </motion.span>
            </span>
          ))}
        </h1>
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 1 }}
          className="mt-8 text-sm leading-relaxed text-[#4A525B] md:text-base"
        >
          {HERO.sub}
        </motion.p>
        <motion.button
          data-testid="hero-requirements-btn"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 1.4 }}
          onClick={() => {
            const el = document.getElementById("scope");
            if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
            else el?.scrollIntoView({ behavior: "smooth" });
          }}
          className="mt-12 rounded-full bg-[#122336] px-7 py-3 text-xs font-semibold uppercase tracking-[0.15em] text-[#F6F5F2] transition-colors duration-300 hover:bg-[#D18237]"
        >
          Scope of service
        </motion.button>
      </div>
    </div>
  </section>
);
